<template>
    <div>
        <div v-for="field in schema.fields" :key="field.name">
            <ValidationObserver ref="form">
                <ValidationProvider
                    v-if="field.name == 'first'"
                    :vid="field.name"
                    :name="field.name"
                    rules="required|confirmedBy:@second"
                    v-slot="{ passed, failed }"
                >
                    <md-field
                        :class="[
                            { 'md-error': failed },
                            { 'md-valid': passed }
                        ]"
                    >
                        <label>{{ field.title }}</label>
                        <md-input
                            type="password"
                            :name="field.name"
                            v-model="modelReactive[field.name]"
                            :placeholder="field.title"
                        />
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="failed"
                                >close</md-icon
                            >
                        </slide-y-down-transition>
                        <slide-y-down-transition>
                            <md-icon class="success" v-show="passed"
                                >done</md-icon
                            >
                        </slide-y-down-transition>
                    </md-field>
                    <p v-if="failed">
                        <b class="text-danger">{{
                            $t("the_passwords_must_match")
                        }}</b>
                    </p>
                </ValidationProvider>

                <ValidationProvider
                    v-if="field.name == 'second'"
                    :vid="field.name"
                    :name="field.name"
                    rules="required"
                    v-slot="{ passed, failed }"
                >
                    <md-field
                        :class="[
                            { 'md-error': failed },
                            { 'md-valid': passed }
                        ]"
                    >
                        <label>{{ field.title }}</label>
                        <md-input
                            type="password"
                            class="form-builder-elements"
                            :name="field.name"
                            v-model="modelReactive[field.name]"
                            :placeholder="field.title"
                        />
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="failed"
                                >close</md-icon
                            >
                        </slide-y-down-transition>
                        <slide-y-down-transition>
                            <md-icon class="success" v-show="passed"
                                >done</md-icon
                            >
                        </slide-y-down-transition>
                    </md-field>
                    <p v-if="failed">
                        <b class="text-danger">{{
                            $t("the_passwords_must_match")
                        }}</b>
                    </p>
                </ValidationProvider>
            </ValidationObserver>
        </div>
    </div>
</template>
<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", required);
extend("confirmedBy", {
    params: ["target"],
    // Target here is the value of the target field
    validate(value, { target }) {
        return value === target;
    },
    // here it is its name, because we are generating a message
    message: "The {_field_} does not match the {target}"
});

export default {
    name: "ObjectInput",
    props: ["placeholder", "title", "name", "value", "attr", "schema", "model"],
    data() {
        return {
            modelReactive: this.model
        };
    }
};
</script>

<style>
.alert-message-password {
    color: red;
}
</style>
